import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const ImageIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 21 21"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 21)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M.5.5h20v20H.5z" />
      <path d="M11.94 6.46a2.6 2.6 0 1 0 2.6-2.6 2.6 2.6 0 0 0-2.6 2.6zM3.28 13.2a7.1 7.1 0 0 1 10.14 3.6M12.81 14.86a3.86 3.86 0 0 1 5.07-.1" />
    </SVG>
  );
};
